import React from 'react';
import { 
	func, 
} from 'prop-types';

export default class Redirect extends React.Component {
	static propTypes = {
		redirectTo : func,
	}

    componentDidMount = ()=>{
    	const {redirectTo} = this.props;
    	if(redirectTo) {
    		redirectTo();
    	}
    }
	
	
    render(){
    	return 'Redirectiong...';
    }
}
